import React, { Fragment, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import VisibilityToggle from "src/Components/Shared/VisibilityToggle/VisibilityToggle";
import { useTranslation } from "react-i18next";

function ForgetPassword({
  visible,
  setVisible,
  changePassword,
  forgetPassword,
  changePasswordVisible,
  setChangePasswordVisible,
  loading,
}: any) {
  const [email, setEmail] = useState("");
  const { t ,i18n} = useTranslation();
  const { handleSubmit, register, errors, watch } = useForm({
    defaultValues: {
      email: "",
      verificationCode: "",
      password: "",
      cnfPassword: "",
    },
  });

  const onSubmit = handleSubmit((_) => {
    forgetPassword(_);
    setEmail(_.email);
  });

  const onChangeSubmit = handleSubmit((_) => changePassword(_, email));

  useEffect(() => {
    setChangePasswordVisible(false);
  }, [setChangePasswordVisible, visible]);

  return (
    <Fragment>
      <div
        className={`modal fade ${visible ? "show" : ""}`}
        id="forgot_password"
        style={{ display: visible ? "block" : "none" }}
        role={"dialog"}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content border-0">
            <div className="modal-body p-4 p-sm-5 custom_modal">
              <VisibilityToggle visible={!changePasswordVisible}>
                <div className={i18n.dir() === "rtl" ? "text-right" :""}>
                  <div className="form-group mb-4">
                    <label className="mb-0">
                      {t('Enter the email address you used to register and we send you a secure link to reset your password')}
                    </label>
                  </div>
                  <div className="form-group">
                    <input
                      type="email"
                      className={`form-control fz12 ${errors.email ? "is-invalid" : ""
                        }`}
                      placeholder={t("Email Address")}
                      name={"email"}
                      ref={register({
                        required: {
                          value: true,
                          message: t("Email is required"),
                        },
                        pattern: {
                          value: /[A-Za-z0-9._%+-]{3,}@[a-zA-Z]{3,}([.]{1}[a-zA-Z]{2,}|[.]{1}[a-zA-Z]{2,}[.]{1}[a-zA-Z]{2,})/,
                          message: t("Email Address is invalid"),
                        },
                      })}
                    />
                    <VisibilityToggle visible={errors.email ? true : false}>
                      <p className="text-danger">{errors.email?.message}</p>
                    </VisibilityToggle>
                  </div>
                  <div className="d-flex justify-content-center mt-4 text-right">
                    <button
                      className={`btn custom_btn text-secondary bg-transparent border border-secondary ${i18n.dir() === "rtl" ? "ml-2" :"mr-2"}`}
                      data-dismiss="modal"
                      onClick={() => setVisible(false)}
                    >
                      {t("Cancel")}
                    </button>
                    <button className="btn custom_btn" onClick={onSubmit}>
                      {t("Submit")}
                    </button>
                  </div>
                </div>
              </VisibilityToggle>

              <VisibilityToggle visible={changePasswordVisible}>
                <div className={i18n.dir() === "rtl" ? "text-right":""}>
                  <div className="form-group mb-4">
                    <label className="mb-0">{t("Change Password")}</label>
                  </div>
                  <div className="form-group">
                    <input
                      type="verificationCode"
                      className={`form-control fz12 ${errors.verificationCode ? "is-invalid" : ""
                        }`}
                      placeholder={t("Enter Verification Code")}
                      name={"verificationCode"}
                      ref={register({
                        required: {
                          value: true,
                          message: t("Verfication code is required"),
                        },
                        maxLength: {
                          value: 6,
                          message: t("Verification code is invalid"),
                        },
                        minLength: {
                          value: 6,
                          message: t("Verification code is invalid"),
                        },
                      })}
                      maxLength={6}
                    />
                    <VisibilityToggle
                      visible={errors.verificationCode ? true : false}
                    >
                      <p className="text-danger">
                        {errors.verificationCode?.message}
                      </p>
                    </VisibilityToggle>
                  </div>
                  <div className="form-group">
                    <input
                      type="password"
                      className={`form-control fz12 ${errors.password ? "is-invalid" : ""
                        }`}
                      placeholder={t("Password")}
                      name={"password"}
                      ref={register({
                        required: {
                          value: true,
                          message: t("Password is required"),
                        },
                      })}
                    />
                    <VisibilityToggle visible={errors.password ? true : false}>
                      <p className="text-danger">{errors.password?.message}</p>
                    </VisibilityToggle>
                  </div>
                  <div className="form-group">
                    <input
                      type="password"
                      className={`form-control fz12 ${errors.password ? "is-invalid" : ""
                        }`}
                      placeholder={t("Confirm Password")}
                      name={"cnfPassword"}
                      ref={register({
                        required: {
                          value: true,
                          message: t("Confirm Password is required"),
                        },
                        validate: {
                          value: (value: any) =>
                            value === watch("password")
                              ? true
                              : t("Passwords do not match")+"",
                        },
                      })}
                    />
                    <VisibilityToggle
                      visible={errors.cnfPassword ? true : false}
                    >
                      <p className="text-danger">
                        {errors.cnfPassword?.message}
                      </p>
                    </VisibilityToggle>
                  </div>
                  <div className="d-flex justify-content-center mt-4 text-right">
                    <button
                      className={`btn custom_btn text-secondary bg-transparent border border-secondary ${i18n.dir() === "rtl" ? "ml-2" :"mr-2"}`}
                      data-dismiss="modal"
                      onClick={() =>
                        changePasswordVisible
                          ? setChangePasswordVisible(false)
                          : setVisible(false)
                      }
                    >
                      {changePasswordVisible ? t("Back") : t("Cancel")}
                    </button>
                    <button
                      disabled={loading}
                      className="btn custom_btn"
                      onClick={
                        changePasswordVisible ? onChangeSubmit : onSubmit
                      }
                    >
                      <VisibilityToggle visible={loading}>
                        <span className="spinner-border spinner-border-sm"></span>
                        &nbsp;
                      </VisibilityToggle>
                      {t("Submit")}
                    </button>
                  </div>
                </div>
              </VisibilityToggle>
            </div>
          </div>
        </div>
      </div>
      <VisibilityToggle visible={visible}>
        <div
          className={`modal-backdrop fade ${visible ? "show" : ""}`}
          onClick={() => setVisible(false)}
        ></div>
      </VisibilityToggle>
    </Fragment>
  );
}

export default ForgetPassword;
